<nav *ngIf="!dialogMode" class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button class="btn btn-outline-success" type="button" [disabled]="!allowToCreate" (click)="onAdd()" title="Nuevo">
            <i class="fa fa-file-o"></i> Nuevo
        </button>
    </form>
</nav>

<div class="container-fluid container-fluid-list" [ngClass]="{ 'container-fluid': !dialogMode, 'container-filter': dialogMode }">
    <app-cultivo-superficie *ngIf="recintoCultivos" [superficieTotal]="recintoCultivos?.SuperficieTotal" [superficieCultivada]="superficieCultivada"></app-cultivo-superficie>

    <app-cultivo-list *ngIf="searching" [dialogMode]="dialogMode" [result]="recintoCultivos?.TwCultivoCollection" [allowToAutorizar]="allowToAutorizar"
        (edit)="onEdit($event)" (view)="onView($event)" (delete)="onDelete($event)" (baja)="onDarDeBaja($event)" (authorize)="onAuthorize($event)">
    </app-cultivo-list>
</div>
